import _defineProperty from "/Users/mac/github/elemental-zcash/zec-map/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/mac/github/elemental-zcash/zec-map/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useState, useCallback, useContext } from 'react';
export var MountedMapsContext = React.createContext(null);
export var MapProvider = function MapProvider(props) {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      maps = _useState2[0],
      setMaps = _useState2[1];

  var onMapMount = useCallback(function (map) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
    setMaps(function (currMaps) {
      if (currMaps[id]) {
        throw new Error("Multiple maps with the same id: ".concat(id));
      }

      return _objectSpread(_objectSpread({}, currMaps), {}, _defineProperty({}, id, map));
    });
  }, []);
  var onMapUnmount = useCallback(function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
    setMaps(function (currMaps) {
      if (currMaps[id]) {
        var nextMaps = _objectSpread({}, currMaps);

        delete nextMaps[id];
        return nextMaps;
      }

      return currMaps;
    });
  }, []);
  return React.createElement(MountedMapsContext.Provider, {
    value: {
      maps: maps,
      onMapMount: onMapMount,
      onMapUnmount: onMapUnmount
    }
  }, props.children);
};
export function useMap() {
  var _useContext = useContext(MountedMapsContext),
      maps = _useContext.maps;

  return maps;
}